import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import Column from '@amzn/meridian/column';
import { MoveIcons, ScanIcons } from 'src/constants/general-media';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';
import SingleChildContainersScanPage
    from 'src/components/pages/child-container-scan/single-mode/SingleChildContainerScanPageContainer';
import DestinationContainerScanPage
    from 'src/components/pages/destination-container-scan/DestinationContainerScanPageContainer';
import { MoveContainerMode } from 'src/models/batchMoveContainers';
import { BatchMoveContainersPages } from 'src/store/common-slices/batchMoveContainersSlice';
import {GetContainerMode} from "src/models/GetContainerDetails";

interface SingleMoveStateProps {
    pageToRender: BatchMoveContainersPages;
    setPageToRender: (pageToRender: BatchMoveContainersPages) => void;
}

interface SingleMoveDispatchProps {
    resetContainerState: () => void;
    resetChildAndDestinationContainers: () => void;
}

type Props = SingleMoveStateProps & SingleMoveDispatchProps;

class SingleMove extends React.Component<Props> {

    private onBackButtonClick = () => {
        this.props.setPageToRender(BatchMoveContainersPages.SCAN_CHILD_CONTAINERS);
    }

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <Column data-testid="single-move">
                        {this.props.pageToRender === BatchMoveContainersPages.SCAN_CHILD_CONTAINERS &&
                            <SingleChildContainersScanPage
                                containerMode={GetContainerMode.MOVE}
                                barcodeScanIcon={ScanIcons.SCAN_HANDHELD_ICON}
                                barcodeScanText={AppStrings.MOVE_MAIN_TEXT}
                                barcodeScanInputLabel={AppStrings.MOVE_INPUT_LABEL}
                                barcodeScanInputPlaceholder={AppStrings.MOVE_INPUT_PLACEHOLDER}
                                barcodeScanButtonText={AppStrings.MOVE_BUTTON}
                                barcodeScanButtonIcon={<img src={MoveIcons.MOVE_DEFAULT_ICON} alt="Move Icon"/>}
                                headingTestId="move-single-heading"
                                inputTestId="move-single-input"
                                buttonTestId="move-single-submit-button"
                            />
                        }

                        {this.props.pageToRender === BatchMoveContainersPages.SCAN_DESTINATION_CONTAINER &&
                            <DestinationContainerScanPage
                                onBackButtonClick={this.onBackButtonClick}
                                pageTitle={AppStrings.MOVE_DESTINATION_CONTAINER_MAIN_TEXT}
                                barcodeScanIcon={ScanIcons.SCAN_TRAILER_ICON}
                                barcodeScanText={AppStrings.MOVE_DESTINATION_SCAN_TEXT}
                                barcodeScanInputLabel={AppStrings.MOVE_DESTINATION_INPUT_LABEL}
                                barcodeScanInputPlaceholder={AppStrings.MOVE_DESTINATION_INPUT_PLACEHOLDER}
                                barcodeScanButtonText={AppStrings.MOVE_BUTTON}
                                barcodeScanButtonIcon={<img src={MoveIcons.MOVE_DEFAULT_ICON} alt="Move Icon"/>}
                                moveContainerMode={MoveContainerMode.MOVE}
                                headingTestId="move-single-destination-heading"
                                inputTestId="move-single-destination-input"
                                buttonTestId="move-single-destination-submit-button"
                            />
                        }

                        <UILoader />
                        <StatusAlert />

                    </Column>
                )}
            </Responsive>
        )
    }

    componentWillUnmount() {
        this.props.resetContainerState();
        this.props.resetChildAndDestinationContainers();
    }
}

export default SingleMove;

